import { render } from "./QueueCallGaugeChart.vue?vue&type=template&id=0dcf7f1a&ts=true"
import script from "./QueueCallGaugeChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueueCallGaugeChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/reports/realtime/components/QueueCallGaugeChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dcf7f1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dcf7f1a', __exports__)) {
    api.reload('0dcf7f1a', __exports__)
  }
  
  module.hot.accept("./QueueCallGaugeChart.vue?vue&type=template&id=0dcf7f1a&ts=true", () => {
    api.rerender('0dcf7f1a', render)
  })

}


export default __exports__